// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--spacing-xxs: 2px;--spacing-xs: 4px;--spacing-s: 8px;--spacing-m: 12px;--spacing-l: 16px;--spacing-xl: 24px;--spacing-xxl: 32px;--spacing-xxl-2: 40px;--spacing-xxl-3: 48px;--spacing-xxl-4: 56px;--spacing-xxl-5: 64px;--spacing-xxl-6: 80px}.b2b-lib-feedback_questions{display:block}\n", ""]);
// Exports
exports.locals = {
	"feedback_questions": "b2b-lib-feedback_questions"
};
module.exports = exports;
